var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-table',{ref:"table",attrs:{"loadObj":{},"dict":[],"option":{},"colObj":{
      opId:304,
      dataClass : 2,
      addBtnClick: _vm.addBtnClick
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }